"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _statementExportApi = require("@/api/statementExportApi");
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi"));
var _merchantStatement = require("@/api/merchantStatement");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t5 in e) "default" !== _t5 && {}.hasOwnProperty.call(e, _t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t5)) && (i.get || i.set) ? o(f, _t5, i) : f[_t5] = e[_t5]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DownloadRecordDialog',
  data: function data() {
    return {
      visible: false,
      listLoading: false,
      list: [],
      pagination: {
        page: 1,
        limit: 20,
        total: 0
      },
      exporting: false,
      exportDetailType: '',
      confirmVisible: false,
      pollingTimer: null,
      merchantInfo: {},
      settledAfterSaleOrderCount: 0,
      // 导出进度相关
      exportProgress: 0,
      exportDialogVisible: false,
      exportDialogTitle: '导出对账单明细',
      exportConditionText: '',
      isInQueue: false,
      currentQueuePosition: 0,
      queueDetail: null,
      customColors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      currentTaskId: null
    };
  },
  computed: {
    processingCount: function processingCount() {
      return this.list.filter(function (t) {
        return t.status === 'PROCESSING' || t.status === 'WAITING';
      }).length;
    }
  },
  methods: {
    open: function open(statementId, statementNo, statementInfo) {
      this.visible = true;
      this._statementId = statementId;
      this._statementNo = statementNo;
      this.buildMerchantInfo(statementInfo);
      this.pagination.page = 1;
      this.settledAfterSaleOrderCount = 0;
      this.fetchSettledAfterSaleOrderCount();
      this.fetchList();
    },
    fetchSettledAfterSaleOrderCount: function fetchSettledAfterSaleOrderCount() {
      var _this = this;
      (0, _merchantStatement.statementSettledAfterSaleOrderCountApi)({
        statementId: this._statementId
      }).then(function (data) {
        _this.settledAfterSaleOrderCount = Number(data) || 0;
      }).catch(function () {
        _this.settledAfterSaleOrderCount = 0;
      });
    },
    buildMerchantInfo: function buildMerchantInfo(statementInfo) {
      if (!statementInfo) {
        this.merchantInfo = {};
        return;
      }
      var typeMap = {
        1: '卡券供应商',
        2: '实物供应商',
        3: '家政供应商',
        4: '核销供应商'
      };
      this.merchantInfo = _objectSpread(_objectSpread({}, statementInfo), {}, {
        merchantTypeText: typeMap[statementInfo.merchantType] || '-'
      });
    },
    handleClosed: function handleClosed() {
      this.stopPolling();
      this.exportDetailType = '';
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _statementExportApi.getStatementExportRecordList)({
        statementId: this._statementId,
        page: this.pagination.page,
        limit: this.pagination.limit
      }).then(function (res) {
        var list = [];
        var total = 0;
        if (res && Array.isArray(res.list)) {
          list = res.list || [];
          total = res.total || 0;
        } else if (Array.isArray(res)) {
          list = res;
          total = res.length;
        }
        _this2.list = list;
        _this2.pagination.total = total;
        _this2.startPolling();
      }).catch(function () {
        _this2.list = [];
      }).finally(function () {
        _this2.listLoading = false;
      });
    },
    startPolling: function startPolling() {
      var _this3 = this;
      this.stopPolling();
      if (this.processingCount === 0) return;
      this.pollingTimer = setInterval(function () {
        _this3.refreshActiveTasks();
      }, 5000);
    },
    stopPolling: function stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    refreshActiveTasks: function refreshActiveTasks() {
      var _this4 = this;
      var activeTasks = this.list.filter(function (t) {
        return t.status === 'PROCESSING' || t.status === 'WAITING';
      });
      activeTasks.forEach(function (task) {
        orderListApi.getDownloadTaskDetail(task.id).then(function (res) {
          var taskData = res && res.data ? res.data : res;
          if (taskData) {
            var i = _this4.list.findIndex(function (t) {
              return t.id === task.id;
            });
            if (i !== -1) {
              _this4.$set(_this4.list, i, _objectSpread(_objectSpread({}, _this4.list[i]), taskData));
            }
          }
        }).catch(function () {});
      });
    },
    handleExport: function handleExport(detailType) {
      this.exportDetailType = detailType === 2 ? 2 : '';
      this.exportDialogTitle = this.exportDetailType === 2 ? '导出已结算售后订单' : '导出对账单明细';
      this.confirmVisible = true;
    },
    doExport: function doExport() {
      var _this5 = this;
      this.exporting = true;
      this.confirmVisible = false;

      // 重置导出状态
      this.exportProgress = 0;
      this.isInQueue = false;
      this.currentQueuePosition = 0;
      this.queueDetail = null;

      // 显示导出进度弹窗
      this.exportDialogVisible = true;
      var taskName = "\u5BF9\u8D26\u5355\u660E\u7EC6\u5BFC\u51FA_".concat(this._statementNo || '');
      var orderSearchRequest = {
        statementId: this._statementId,
        detailType: this.exportDetailType === 2 ? 2 : 1
      };
      (0, _statementExportApi.createStatementOrderExportTask)({
        statementId: this._statementId,
        statementNo: this._statementNo,
        taskName: taskName,
        orderSearchRequest: orderSearchRequest
      }).then(function (res) {
        // 关闭确认弹窗
        _this5.exporting = false;

        // 解析返回的taskId和队列信息
        var taskId = res && res.taskId;
        if (taskId) {
          _this5.currentTaskId = taskId;
        }
        if (res && res.inQueue) {
          // 进入排队队列
          _this5.isInQueue = true;
          _this5.currentQueuePosition = res.queuePosition || 0;
          _this5.fetchQueueDetailAndUpdate('STATEMENT_ORDER_EXPORT', taskId);
        } else {
          // 直接执行
          _this5.isInQueue = false;
          _this5.pollTaskStatus(taskId);
        }
      }).catch(function (err) {
        _this5.exporting = false;
        _this5.exportDialogVisible = false;
        _this5.$message.error(err.message || '创建导出任务失败');
      });
    },
    // 获取排队详情并更新位置
    fetchQueueDetailAndUpdate: function () {
      var _fetchQueueDetailAndUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(taskType, taskId) {
        var detail, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _statementExportApi.getStatementExportQueueDetail)(taskType);
            case 1:
              detail = _context.v;
              if (detail) {
                this.queueDetail = detail;
                if (detail.userMaxQueuePosition > 0) {
                  this.currentQueuePosition = detail.userMaxQueuePosition;
                }
              }
              // 继续轮询状态
              this.pollTaskStatusWithQueue(taskId, taskType);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取排队详情失败:', _t);
              this.pollTaskStatusWithQueue(taskId, taskType);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchQueueDetailAndUpdate(_x, _x2) {
        return _fetchQueueDetailAndUpdate.apply(this, arguments);
      }
      return fetchQueueDetailAndUpdate;
    }(),
    // 轮询任务状态
    pollTaskStatus: function () {
      var _pollTaskStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(taskId) {
        var _this6 = this;
        var pollInterval;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var res, taskStatus, _t2;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.p = _context2.n) {
                    case 0:
                      _context2.p = 0;
                      _context2.n = 1;
                      return (0, _statementExportApi.getStatementExportTaskStatus)(taskId);
                    case 1:
                      res = _context2.v;
                      taskStatus = res && res.data ? res.data : res;
                      if (taskStatus.status === 'PROCESSING') {
                        _this6.exportProgress = Math.min(_this6.exportProgress + 5, 90);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this6.exportProgress = 100;
                        clearInterval(pollInterval);
                        if (taskStatus.filePath) {
                          (0, _statementExportApi.downloadFileByPath)(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          orderListApi.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this6.exportDialogVisible = false;
                          _this6.pagination.page = 1;
                          _this6.fetchList();
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this6.exportDialogVisible = false;
                        _this6.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      } else if (taskStatus.status === 'CANCELLED') {
                        clearInterval(pollInterval);
                        _this6.exportDialogVisible = false;
                        _this6.$message.warning('导出任务已中止');
                      } else {
                        clearInterval(pollInterval);
                        _this6.exportDialogVisible = false;
                      }
                      _context2.n = 3;
                      break;
                    case 2:
                      _context2.p = 2;
                      _t2 = _context2.v;
                      clearInterval(pollInterval);
                      _this6.exportDialogVisible = false;
                      _this6.$message.error('查询任务状态失败: ' + _t2.message);
                    case 3:
                      return _context2.a(2);
                  }
                }, _callee2, null, [[0, 2]]);
              })), 2000);
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function pollTaskStatus(_x3) {
        return _pollTaskStatus.apply(this, arguments);
      }
      return pollTaskStatus;
    }(),
    // 轮询任务状态（支持排队模式）
    pollTaskStatusWithQueue: function () {
      var _pollTaskStatusWithQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(taskId, taskType) {
        var _this7 = this;
        var pollInterval;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              pollInterval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var detail, res, taskStatus, _t3, _t4;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.p = _context4.n) {
                    case 0:
                      _context4.p = 0;
                      _context4.p = 1;
                      _context4.n = 2;
                      return (0, _statementExportApi.getStatementExportQueueDetail)(taskType);
                    case 2:
                      detail = _context4.v;
                      if (detail) {
                        _this7.queueDetail = detail;
                        if (detail.userMaxQueuePosition > 0) {
                          _this7.currentQueuePosition = detail.userMaxQueuePosition;
                        }
                      }
                      _context4.n = 4;
                      break;
                    case 3:
                      _context4.p = 3;
                      _t3 = _context4.v;
                    case 4:
                      _context4.n = 5;
                      return (0, _statementExportApi.getStatementExportTaskStatus)(taskId);
                    case 5:
                      res = _context4.v;
                      taskStatus = res && res.data ? res.data : res;
                      if (taskStatus.status === 'WAITING') {
                        _this7.currentQueuePosition = taskStatus.queuePosition || 0;
                      } else if (taskStatus.status === 'PROCESSING') {
                        _this7.isInQueue = false;
                        _this7.exportProgress = 5;
                        clearInterval(pollInterval);
                        _this7.pollTaskStatus(taskId);
                      } else if (taskStatus.status === 'COMPLETED') {
                        _this7.exportProgress = 100;
                        clearInterval(pollInterval);
                        if (taskStatus.filePath) {
                          (0, _statementExportApi.downloadFileByPath)(taskStatus.filePath, taskStatus.fileName);
                        } else if (taskStatus.fileName) {
                          orderListApi.downloadFile(taskStatus.fileName);
                        }
                        setTimeout(function () {
                          _this7.exportDialogVisible = false;
                          _this7.pagination.page = 1;
                          _this7.fetchList();
                        }, 1500);
                      } else if (taskStatus.status === 'FAILED') {
                        clearInterval(pollInterval);
                        _this7.exportDialogVisible = false;
                        _this7.$message.error('导出失败: ' + (taskStatus.errorMessage || '未知错误'));
                      } else if (taskStatus.status === 'CANCELLED') {
                        clearInterval(pollInterval);
                        _this7.exportDialogVisible = false;
                        _this7.$message.warning('导出任务已中止');
                      } else {
                        clearInterval(pollInterval);
                        _this7.exportDialogVisible = false;
                      }
                      _context4.n = 7;
                      break;
                    case 6:
                      _context4.p = 6;
                      _t4 = _context4.v;
                      clearInterval(pollInterval);
                      _this7.exportDialogVisible = false;
                      _this7.$message.error('查询任务状态失败: ' + _t4.message);
                    case 7:
                      return _context4.a(2);
                  }
                }, _callee4, null, [[1, 3], [0, 6]]);
              })), 2000);
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      function pollTaskStatusWithQueue(_x4, _x5) {
        return _pollTaskStatusWithQueue.apply(this, arguments);
      }
      return pollTaskStatusWithQueue;
    }(),
    // 格式化等待时间
    formatWaitTime: function formatWaitTime(seconds) {
      if (!seconds || seconds <= 0) return '即将开始';
      if (seconds < 60) return "".concat(seconds, "\u79D2");
      if (seconds < 3600) return "".concat(Math.floor(seconds / 60), "\u5206\u949F");
      return "".concat(Math.floor(seconds / 3600), "\u5C0F\u65F6").concat(Math.floor(seconds % 3600 / 60), "\u5206\u949F");
    },
    handleFileDownload: function handleFileDownload(row) {
      if (!row.filePath) {
        this.$message.error('文件路径不存在');
        return;
      }
      (0, _statementExportApi.downloadFileByPath)(row.filePath, row.fileName);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(val) {
      this.pagination.page = val;
      this.fetchList();
    },
    statusText: function statusText(status) {
      var map = {
        PENDING: '等待处理',
        WAITING: '排队中',
        PROCESSING: '导出中',
        COMPLETED: '导出成功',
        FAILED: '导出失败',
        CANCELLED: '已中止'
      };
      return map[status] || status;
    },
    statusTagType: function statusTagType(status) {
      var map = {
        PENDING: 'info',
        WAITING: 'warning',
        PROCESSING: 'primary',
        COMPLETED: 'success',
        FAILED: 'danger',
        CANCELLED: 'warning'
      };
      return map[status] || 'info';
    },
    formatDateTime: function formatDateTime(dateTime) {
      if (!dateTime) return '-';
      var date = new Date(dateTime);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    }
  }
};